import App from './app.component';

export default App;
